import AbilityScoresManage from './AbilityScoresManage';

export default AbilityScoresManage;
export { AbilityScoresManage };
